import React from 'react';
import {
	FormattedMessage,
	FormattedNumber,
	defineMessages,
} from 'react-intl';
import {
	useSelector,
} from 'react-redux';

import SitemapsTable from './SitemapsTable';

import {
	loadData as loadSitemaps,
	selector as sitemapsSelector,
} from '~/state/sitemapsViolatingUrlcountLimit';



const messages = defineMessages({
	numberOfRecords: {
		id: 'ui.screen.sitemapsList.headings.items.label',
	},
	url: {
		id: 'ui.screen.sitemapsList.headings.sitemap.label',
	},
});



type Props = {
	tableWidth: number,
};

const SitemapsViolatingUrlcountLimitTable: React.FC<Props> = (props) => {
	const {
		tableWidth,
	} = props;

	const sitemaps = useSelector(sitemapsSelector);

	const urlColumnWidth = Math.floor(tableWidth * 0.8);

	return (
		<SitemapsTable
			columns={[
				{
					render: {
						cell: ({ row }) => row.url,
						header: () => <FormattedMessage {...messages.url} />,
					},
					width: urlColumnWidth,
				},
				{
					render: {
						cell: ({ row }) => (
							<FormattedNumber value={row.number_of_records} />
						),
						header: () => <FormattedMessage {...messages.numberOfRecords} />,
					},
					width: tableWidth - urlColumnWidth - 2,
				},
			]}
			loadData={loadSitemaps}
			sitemaps={sitemaps}
			tableWidth={tableWidth}
		/>
	);
};



export default SitemapsViolatingUrlcountLimitTable;
